import { CLEAR_DOWNLOAD_STORYBOARD, DOWNLOAD_STORYBOARD, FETCH_STORYBOARD, RESET_DOWNLOAD_STORYBOARD, SAVE_STORYBOARD_SETTINGS } from "./actions";

interface StoryboardState {
    scenes: any[];
    shotsByScene: { [key: string]: any } | any;
    loading: boolean;
    errors: any;
    settings: any;
    download: any | null;
    progress: any;
}

const defaultState: StoryboardState = {
    scenes: [],
    shotsByScene: {},
    loading: true,
    errors: null,
    settings: null,
    download: null,
    progress: null
};

const reducer = (state: StoryboardState = defaultState, action: any = {}) => {
    switch (action.type) {
        case FETCH_STORYBOARD + "_PENDING":
            return { ...state, loading: true, errors: null };

        case FETCH_STORYBOARD + "_FULFILLED":
            return {
                ...state,
                loading: false,
                scenes: action.payload.data.scenes,
                settings: action.payload.data.settings || null,
                errors: null
            };

        case SAVE_STORYBOARD_SETTINGS + "_PENDING":
            return { ...state };

        case SAVE_STORYBOARD_SETTINGS + "_FULFILLED":
            return { ...state, settings: action.payload.data.settings || state.settings };

        case DOWNLOAD_STORYBOARD + "_PENDING":
            return { ...state, loading: false, progress: { progress: null, message: 'Queued for generating PDF' } };

        case DOWNLOAD_STORYBOARD + "_FULFILLED":
            return state;

        case DOWNLOAD_STORYBOARD + "_COMPLETE":
            return { ...state, loading: false, progress: null, download: { url: action.meta.url, fileName: action.meta.fileName, downloaded: false } };

        case CLEAR_DOWNLOAD_STORYBOARD: {
            var download = { ...state.download, downloaded: true }
            return { ...state, download };
        }

        case RESET_DOWNLOAD_STORYBOARD: {
            var download: any = null;
            return { ...state, download };
        }

        case DOWNLOAD_STORYBOARD + "_PROGRESS":
            return { ...state, progress: action.meta.progress };

        case DOWNLOAD_STORYBOARD + "_ERRORED":
            return { ...state, progress: null, errors: action.meta.errors };

        case FETCH_STORYBOARD + "_REJECTED":
            return { ...state, loading: false, errors: action.payload };

        default:
            return state;
    }
};

export default reducer;
